/**
 * Detects if the content of an HTMLElement overflows its boundaries.
 *
 * @param {HTMLElement} el - The HTMLElement to check for overflow.
 * @returns {boolean} - `true` if overflow is detected, `false` otherwise.
 * @deprecated This function is no longer recommended for use and has been replaced by 'hasOverflow'.
 */
export function detectOverflow(el: HTMLElement) {
  var styleOverflow = el.style.overflow

  if (!styleOverflow || styleOverflow === 'visible') el.style.overflow = 'hidden'

  var overflowed = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight

  el.style.overflow = styleOverflow

  return overflowed
}
